export const blogUrl = 'https://blog.veroo.com.br';
export const supportUrl = 'https://veroo.cafe/contato';
export const instagramUrl = 'https://instagram.com/veroocafes';
export const knowMore = 'https://veroo.cafe/saiba-mais-site';
export const contentCenterUrl = 'https://veroo.cafe/centraldeconteudos';
